/**
 * Whether a url may be embedded in the iframe modal: any http(s) page, on any
 * origin. Other schemes are refused because `javascript:` would run in our page.
 *
 * ⚠ TOTAL, because it is a security guard: a non-string, a malformed url or a
 * non-http scheme returns `false` rather than throwing. With no `window`
 * (server render) a relative url cannot resolve, so it is refused there too.
 *
 * @param rawUrl The candidate `src`, as authored.
 */
export function isAllowedOrigin(rawUrl: unknown): boolean {
  if (typeof rawUrl !== "string" || rawUrl.trim() === "") {
    return false;
  }

  /* No window (server render) means nothing to resolve a relative url against
     — refuse, and let the client effect validate. */
  if (typeof window === "undefined") {
    return false;
  }

  let resolved: URL;
  try {
    resolved = new URL(rawUrl, window.location.href);
  } catch {
    return false;
  }

  /* Embedding is http(s) only. `javascript:` runs in our origin, `data:` and
     `blob:` frame author-controlled bytes — none is a page we trust. */
  return resolved.protocol === "https:" || resolved.protocol === "http:";
}
